import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class CqQuestionService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/cq-questions', query);
  }

  create(body: any) {
    return this.post('/cq-questions', body);
  }

  find(id) {
    return this.get('/cq-questions/' + id);
  }

  update(id, body) {
    return this.put('/cq-questions/' + id, body);
  }

  _delete(id) {
    return this.delete('/cq-questions/' + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/CqQuestion.service.ts